(() => {
  const sticky = document.querySelector('.rr-sticky');
  const trigger = document.getElementById('reason-2');
  const offer = document.getElementById('restore-offer');
  if (!sticky || !trigger || !offer) return;
  const mobile = window.matchMedia('(max-width: 768px)');
  let scheduled = false;
  function update() {
    scheduled = false;
    const offerBox = offer.getBoundingClientRect();
    const offerVisible = offerBox.top < window.innerHeight && offerBox.bottom > 0;
    sticky.hidden = !mobile.matches || trigger.getBoundingClientRect().bottom > 0 || offerVisible;
  }
  function schedule() {
    if (!scheduled) { scheduled = true; window.requestAnimationFrame(update); }
  }
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pageshow', update);
  update();
})();

// Load real video sources only near the viewport. Placeholder slots never request missing files.
(() => {
  const videos = [...document.querySelectorAll('.rr-video:not(.rr-video-placeholder) video')];
  const visible = new Set();
  function load(video) {
    if (video.dataset.loaded) return;
    if (video.dataset.src) video.src = video.dataset.src;
    video.querySelectorAll('source[data-src]').forEach(source => { source.src = source.dataset.src; });
    video.dataset.loaded = 'true';
    video.muted = true;
    video.load();
  }
  function update(video) {
    if (visible.has(video) && !document.hidden) {
      load(video);
      video.play().catch(() => { /* Browser autoplay restrictions may leave the poster visible. */ });
    } else video.pause();
  }
  const preload = new IntersectionObserver(entries => {
    entries.forEach(entry => { if (entry.isIntersecting) load(entry.target); });
  }, { rootMargin: '200px' });
  const playback = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) visible.add(entry.target); else visible.delete(entry.target);
      update(entry.target);
    });
  }, { threshold: 0.15 });
  videos.forEach(video => {
    video.autoplay = true;
    video.loop = true;
    video.muted = true;
    video.playsInline = true;
    video.controls = false;
    preload.observe(video);
    playback.observe(video);
  });
  document.addEventListener('visibilitychange', () => videos.forEach(update));
})();

// Native modal dialog provides focus containment and Escape-to-close.
(() => {
  const dialog = document.getElementById('restore-facts-dialog');
  const trigger = document.querySelector('.rr-facts-trigger');
  if (!dialog || !trigger) return;
  let previousOverflow;
  trigger.addEventListener('click', () => {
    if (dialog.open) return;
    previousOverflow = document.documentElement.style.overflow;
    dialog.showModal();
    document.documentElement.style.overflow = 'hidden';
  });
  dialog.querySelector('.rr-facts-close').addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', event => {
    const box = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom)) dialog.close();
  });
  dialog.addEventListener('close', () => {
    document.documentElement.style.overflow = previousOverflow;
    trigger.focus({ preventScroll: true });
  });
})();

// Show the visitor's current date, including after returning to an open tab.
(() => {
  const dates = document.querySelectorAll('[data-current-date]');
  function refreshDate() {
    const now = new Date();
    const label = new Intl.DateTimeFormat('en-US', { month: 'long', day: 'numeric', year: 'numeric' }).format(now);
    const value = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`;
    dates.forEach(date => { date.textContent = label; date.dateTime = value; });
  }
  refreshDate();
  setInterval(refreshDate, 60000);
  document.addEventListener('visibilitychange', refreshDate);
})();
